'use client';

import React from 'react';
import { useAppSelector } from '@/store/hooks';
import { getDrawerContent } from '@/store/reducers/drawer-content-slice';
import { Button, Stack } from '@mui/material';
import { Box } from '@mui/system';

import { Row } from '@/types/general';
import { HorizontalTable } from '@/components/core/horizontal-table';
import { PlayerCell } from '@/components/core/player-cell';

export default function BankAccountDetailsContent(): React.JSX.Element | null {
  const { BANK_ACCOUNT: data } = useAppSelector(getDrawerContent);

  const bankAccountData: Row[] = [
    {
      label: {
        text: 'Player',
      },
      value: {
        component: <PlayerCell playerCode={data?.player?.playerCode || ''} playerId={data?.player?.playerId} />,
      },
    },
    {
      label: {
        text: 'Bank Name',
      },
      value: {
        text: data?.bankName,
      },
    },
    {
      label: {
        text: 'Name On Card',
      },
      value: {
        text: data?.nameOnCard,
      },
    },
    {
      label: {
        text: 'IBAN',
      },
      value: {
        text: data?.iban,
      },
    },
  ];

  return (
    <Stack gap={4}>
      <HorizontalTable header="Status Update" tableData={bankAccountData} status={data?.status} />
      <Box sx={{ textAlign: 'end' }}>
        <Button variant="contained" type="submit">
          Save Changes
        </Button>
      </Box>
    </Stack>
  );
}
